export const ALLOWED_FILE_TYPES = [
  '.pdf',
  '.doc',
  '.docx',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  '.ppt',
  '.pptx',
  '.csv',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/plain',
].join(', ');
export const ALLOWED_IMAGE_TYPES = 'image/png, image/gif, image/jpeg';
export const ALLOWED_VIDEO_TYPES =
  'video/mp4, video/mkv, video/quicktime, video/avi, video/x-flv, video/mpeg, video/webm, video/3gpp';
